import React from "react"
import { useParallax } from "../../hooks/useScroll"
import { classNames } from "../../utils/classNames"

const ParallaxBackground = ({
  imageUrl,
  children,
  strength = 0.3,
  overlayColor = "bg-black",
  overlayOpacity = "bg-opacity-30",
}) => {
  const offsetY = useParallax(strength)

  return (
    <div
      className="relative bg-fixed bg-cover bg-center bg-no-repeat"
      style={{
        backgroundImage: `url(${imageUrl})`,
        backgroundPositionY: `${offsetY}px`,
        minHeight: "100vh",
      }}
    >
      <div
        className={classNames("absolute inset-0", overlayColor, overlayOpacity)}
      ></div>
      {children}
    </div>
  )
}

export default ParallaxBackground
